import useLeadContactMethods from "@/modules/lead-page/hooks/lead-info/lead-contact-methods.hook";
import { useTelephoneContext } from "@/modules/lead-page/new/hooks/telephone-context.hook";
import useTelephoneMenuActions from "@/modules/lead-page/new/hooks/telephone-menu-action.hook";
import { MuiTelInputInfo } from "mui-tel-input";
import { useState, useEffect, useRef } from "react";

const useTelephoneActions = () => {
  const { telephone } = useTelephoneContext();

  const [showAddTelephoneInput, setShowAddTelephoneInput] = useState(false);

  const { handleSearchTruecaller: searchTruecaller } = useLeadContactMethods();

  const { currentTelephoneForMenu, handleMenuClose } =
    useTelephoneMenuActions();

  const telephoneHook = telephone;

  const wasAddingTelephone = useRef(false);
  useEffect(() => {
    if (
      wasAddingTelephone.current &&
      !telephoneHook.addTelephone.isAddingTelephone &&
      !telephoneHook.addTelephone.isErrorAddTelephone
    ) {
      setShowAddTelephoneInput(false);
    }
    wasAddingTelephone.current = telephoneHook.addTelephone.isAddingTelephone;
  }, [
    telephoneHook.addTelephone.isAddingTelephone,
    telephoneHook.addTelephone.isErrorAddTelephone,
  ]);

  const handlePhoneChange = (value: string, info: MuiTelInputInfo) => {
    const defaultDialCode = "+20";
    const dialCode = info.countryCallingCode
      ? `+${info.countryCallingCode}`
      : defaultDialCode;

    let updatedValue = value;
    if (!value.startsWith(dialCode)) {
      updatedValue = `${dialCode} ${value.replace(/^\+?\d*/, "").trim()}`;
    }

    const customEvent = {
      target: {
        value: updatedValue,
      },
    } as React.ChangeEvent<HTMLInputElement>;

    telephoneHook.handleChangeTelephone(customEvent);
  };

  const handleAddTelephone = () => {
    telephoneHook.addTelephone.handleAddTelephone();
  };

  const handleToggleAddForm = () => {
    if (showAddTelephoneInput) {
      // Cancel - clear form and hide
      setShowAddTelephoneInput(false);
      telephoneHook.setTelephone("");
    } else {
      // Show add form
      setShowAddTelephoneInput(true);
    }
  };

  const handleSetDefault = () => {
    if (currentTelephoneForMenu) {
      telephoneHook.makeTelephonePrimary.setTelephoneIdToMakeDefault(
        currentTelephoneForMenu.uid
      );
      telephoneHook.makeTelephonePrimary.handleMakeTelephonePrimary(
        currentTelephoneForMenu.uid
      );
    }
    handleMenuClose();
  };

  const handleDelete = () => {
    if (currentTelephoneForMenu) {
      telephoneHook.deleteTelephone.setTelephoneIdToDelete(
        currentTelephoneForMenu.uid
      );
      telephoneHook.deleteTelephone.handleDeleteTelephone(
        currentTelephoneForMenu.uid
      );
    }
    handleMenuClose();
  };

  const handleTruecaller = () => {
    if (currentTelephoneForMenu) {
      searchTruecaller(currentTelephoneForMenu.telephone);
    }
    handleMenuClose();
  };

  return {
    showAddTelephoneInput,
    setShowAddTelephoneInput,
    handlePhoneChange,
    handleAddTelephone,
    handleToggleAddForm,
    handleSetDefault,
    handleDelete,
    handleTruecaller,
  };
};

export default useTelephoneActions;
